import { render, staticRenderFns } from "./UlkeTelefon.vue?vue&type=template&id=10aa7969"
import script from "./UlkeTelefon.vue?vue&type=script&lang=ts"
export * from "./UlkeTelefon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports